export default "__VITE_ASSET__Ckt_qt9w__"